var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWingsBronze(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 18,
    viewBox: "0 0 36 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.27526 12.7609C11.5506 13.0547 13.5356 13.9787 14.9411 15.2517C15.2355 15.5183 15.1258 16.3671 14.7735 16.5502C13.0907 17.4244 10.936 17.8138 8.66072 17.52C6.38539 17.2261 4.40036 16.3021 2.99485 15.0291C2.70048 14.7625 2.81013 13.9138 3.16252 13.7307C4.84527 12.8565 6.99993 12.4671 9.27526 12.7609Z",
    fill: "url(#paint0_linear_21983_223933)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53872 9.57417C11.9721 10.6291 13.8811 12.2912 15.0347 14.1552C15.2763 14.5456 14.8828 15.4533 14.4327 15.5438C12.2836 15.9761 9.76548 15.7187 7.33221 14.6637C4.89888 13.6088 2.98983 11.9468 1.83621 10.0827C1.59466 9.69234 1.98818 8.78463 2.43822 8.69408C4.5873 8.26193 7.10538 8.51925 9.53872 9.57417Z",
    fill: "url(#paint1_linear_21983_223933)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3692 4.55086C12.8503 6.78144 14.4635 9.52688 15.0948 12.2113C15.227 12.7735 14.3949 13.6991 13.8219 13.6273C11.0856 13.2842 8.18463 11.9712 5.70353 9.7405C3.22242 7.50993 1.60918 4.76449 0.977883 2.08002C0.845679 1.51785 1.67777 0.592265 2.25081 0.664103C4.98704 1.00722 7.88807 2.32029 10.3692 4.55086Z",
    fill: "url(#paint2_linear_21983_223933)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1392 12.7609C24.8639 13.0547 22.8789 13.9787 21.4734 15.2517C21.179 15.5183 21.2886 16.3671 21.641 16.5502C23.3238 17.4244 25.4784 17.8138 27.7538 17.52C30.0291 17.2261 32.0141 16.3021 33.4196 15.0291C33.714 14.7625 33.6044 13.9138 33.252 13.7307C31.5692 12.8565 29.4146 12.4671 27.1392 12.7609Z",
    fill: "url(#paint3_linear_21983_223933)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8732 9.57417C24.4399 10.6291 22.5308 12.2912 21.3772 14.1552C21.1357 14.5456 21.5292 15.4533 21.9792 15.5438C24.1283 15.9761 26.6465 15.7187 29.0797 14.6637C31.5131 13.6088 33.4221 11.9468 34.5757 10.0827C34.8173 9.69234 34.4238 8.78463 33.9737 8.69408C31.8246 8.26193 29.3066 8.51925 26.8732 9.57417Z",
    fill: "url(#paint4_linear_21983_223933)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0434 4.55086C23.5623 6.78144 21.949 9.52688 21.3177 12.2113C21.1855 12.7735 22.0176 13.6991 22.5906 13.6273C25.327 13.2842 28.2279 11.9712 30.709 9.7405C33.1901 7.50993 34.8034 4.76449 35.4347 2.08002C35.5669 1.51785 34.7348 0.592265 34.1617 0.664103C31.4255 1.00722 28.5245 2.32029 26.0434 4.55086Z",
    fill: "url(#paint5_linear_21983_223933)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21983_223933",
    x1: 9.27025,
    y1: 13.7557,
    x2: 9.24214,
    y2: 15.8183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21983_223933",
    x1: 8.7638,
    y1: 10.0921,
    x2: 8.70838,
    y2: 13.1107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_21983_223933",
    x1: 8.38436,
    y1: 3.51913,
    x2: 8.21705,
    y2: 8.91676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_21983_223933",
    x1: 27.7488,
    y1: 13.7557,
    x2: 27.7207,
    y2: 15.8183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_21983_223933",
    x1: 28.3048,
    y1: 10.0921,
    x2: 28.2494,
    y2: 13.1107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_21983_223933",
    x1: 28.7242,
    y1: 3.51913,
    x2: 28.5569,
    y2: 8.91676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWingsBronze);
export default __webpack_public_path__ + "static/media/wings_bronze.1f0237bc57c989401b16e61e2411117f.svg";
export { ForwardRef as ReactComponent };